import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { getItem } from "../../api/generics";
import { Receipt, formatReceiptNumber } from "../../models/receipt";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import ReceiptDetailView from "./ReceiptDetailView";

interface ReceiptDetailModalProps {
  show: boolean;
  receipt?: Receipt;
  onCancel: () => void;
}

const ReceiptDetailModal: React.FC<ReceiptDetailModalProps> = ({
  show,
  receipt,
  onCancel,
}) => {
  const [fullReceipt, setFullReceipt] = useState<Receipt | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !receipt?.id) {
      setFullReceipt(undefined);
      return;
    }
    const fetch = async () => {
      setLoading(true);
      const result = await getItem<Receipt>(`/receipts/${receipt.id}/`);
      if (result.status === SUCCESS && result.data) {
        setFullReceipt(result.data);
      } else {
        errorAlert("No se pudo cargar el detalle del recibo.");
        onCancel();
      }
      setLoading(false);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, receipt?.id]);

  const title =
    receipt?.receiptNumber
      ? `Recibo ${formatReceiptNumber(receipt)}`
      : "Detalle de Recibo";

  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          fullReceipt && <ReceiptDetailView receipt={fullReceipt} />
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReceiptDetailModal;
